import React, { Component } from 'react';
import { Card, Input, List, Modal, Form, Select, Button, message } from 'antd'
import { getMethod, axiosPost } from '../../server/index'
import { getCookieNew } from '../../public/utils';
import { find, get, set } from 'lodash'
import common from '../../public/common'
import ChangePassWord from '../../compenents/changepassword/changepassword';
import BindPhoneModal from './components/bindPhone';
import BindEmailModal from './components/bindEmail';
class SafeSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bindEmailOpen: false,
      bindPhoneOpen: false,
      changePasswordStatus: false,
      options: [
        {
          title: "账户密码登录",
          status: "",
          tips: "安全性高的密码可以使账号更安全，建议定期更换密码，密码可为 6-16位的字母数字组合，区分大小写。",
          rightOptions: "修改",
        }, {
          title: "绑定手机",
          status: "",
          tips: "未绑定，绑定手机后，您可以通过手机号使用找回密码等功能。",
          rightOptions: "绑定",
        }, {
          title: "绑定邮箱",
          status: 0,
          tips: "未绑定，绑定邮箱后，您可以通过邮箱使用找回密码等功能。",
          rightOptions: "绑定",
        }
      ]
    }
  }

  componentDidMount() {
    this.init()
  }


  init = async () => {
    if (!getCookieNew('phone')) {
      return
    }
    let { options } = this.state
    let authWaysRes = await getMethod(common.eurekaUrlDic + `/auth/query-auth-way?account=${getCookieNew('phone')}`)
    let email = get(authWaysRes, "data.data.email")
    let phone_number = get(authWaysRes, "data.data.phone_number")
    if (email) { // 已绑定邮箱
      let target = find(options, { title: "绑定邮箱" })
      set(target, "status", 1)
      set(target, "tips", `已绑定邮箱：${email}，绑定邮箱后，您可以通过邮箱使用找回密码等功能。`)
      set(target, "rightOptions", "修改")
    }
    if (phone_number) {
      let target = find(options, { title: "绑定手机" })
      set(target, "status", 1)
      set(target, "tips", `已绑定手机：${phone_number}，绑定手机后，您可以通过手机号使用找回密码等功能。`)
      set(target, "rightOptions", "修改")
    }
    this.setState({
      options,
    })
  }

  render() {
    return (
      <div style={{ background: "white" }}>
        <Card title="安全设置" bordered={false}>
          <List
            itemLayout="horizontal"
            dataSource={this.state.options}
            renderItem={item => {
              let btn = null
              let title = item.title
              if (title === "账户密码登录") {
                btn = <a onClick={() => { this.setState({ changePasswordStatus: true }) }} key="list-loadmore-edit">{item.rightOptions}</a>
              } else if (title === "绑定手机") {
                btn = <a onClick={() => { this.setState({ bindPhoneOpen: true }) }} key="list-loadmore-edit">{item.rightOptions}</a>
              } else if (title === "绑定邮箱") {
                btn = <a onClick={() => { this.setState({ bindEmailOpen: true }) }} key="list-loadmore-edit">{item.rightOptions}</a>
              }
              return (
                <List.Item
                  actions={[btn]}
                >
                  <List.Item.Meta
                    title={item.title}
                    description={item.tips}
                  />
                </List.Item>
              )
            }}
          />
        </Card>
        <ChangePassWord
          passwordChange={(val) => { this.setState({ changePasswordStatus: val }) }}
          isClick={true}
          changePasswordStatus={this.state.changePasswordStatus}
        />
        <BindPhoneModal
          onCancel={() => { this.setState({ bindPhoneOpen: false, }) }}
          open={this.state.bindPhoneOpen}
        />
        <BindEmailModal
          onCancel={() => { this.setState({ bindEmailOpen: false, }) }}
          open={this.state.bindEmailOpen}
        />
      </div>
    );
  }
}

export default SafeSetting;


// WEBPACK FOOTER //
// ./src/pages/login/setting.jsx